import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'

import { createHerbicideTreatment } from '@/services/create-herbicide-treatment'
import {
  editHerbicideTreatment,
  EditHerbicideTreatmentPayload,
} from '@/services/edit-herbicide-treatment'
import { queryClient } from '@/services/query-client'

import { GET_HERBICIDE_TREATMENTS_QUERY } from '../queries/use-get-herbicide-treatments'

type UseSaveHerbicideTreatmentProps = {
  id?: string
}

export function useSaveHerbicideTreatment({
  id,
}: UseSaveHerbicideTreatmentProps) {
  const mutation = useMutation({
    mutationFn: id
      ? (payload: EditHerbicideTreatmentPayload) =>
          editHerbicideTreatment(id, payload)
      : createHerbicideTreatment,
    onSuccess: () => {
      queryClient.invalidateQueries(GET_HERBICIDE_TREATMENTS_QUERY)
    },
    onError: (error: Error) => {
      toast.error(
        `Não foi possível salvar as informações, tente novamente mais tarde. [${error?.message}]`,
      )
    },
  })

  return mutation
}
